module.exports = __webpack_public_path__ + "img/12@2x.12194996.png";